import { render } from "./topList.vue?vue&type=template&id=f91a6480&scoped=true"
import script from "./topList.vue?vue&type=script&lang=js"
export * from "./topList.vue?vue&type=script&lang=js"

import "./topList.vue?vue&type=style&index=0&id=f91a6480&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f91a6480"]])

export default __exports__